import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FaCode, FaGraduationCap, FaBriefcase } from "react-icons/fa";

const AboutContainer = styled.div`
  padding: 4rem 2rem;
  min-height: 100vh;
  background: rgb(0, 111, 221);
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Segoe UI', sans-serif;

  @media (min-width: 768px) {
    padding: 6rem 4rem;
  }
`;

const ContentWrapper = styled.div`
  max-width: 1200px;
  width: 100%;
  display: grid;
  gap: 2rem;
  grid-template-columns: 1fr;
  padding: 1rem;

  @media (min-width: 992px) {
    grid-template-columns: 300px 1fr;
  }
`;

const ProfileSection = styled.a<{ secondary?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: ${({ secondary }) => (secondary ? "#ffa726" : "#2a5298")};
  color: white;
  border-radius: 6px;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  border: 2px solid transparent;
  flex-direction: column;
  align-items: center;

  &:hover {
    background: ${({ secondary }) => (secondary ? "#ff9800" : "#1e3c72")};
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  svg {
    margin-bottom: 2px;
  }
`;

const ProfileImage = styled.div`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background: #2a5298;
  margin: 0 auto 1.5rem;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const InfoSection = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  margin-top: 2rem;
`;

const SectionTitle = styled.h2`
  font-size: 2rem;
  color: #2a5298;
  margin-bottom: 1.5rem;
  position: relative;
  padding-bottom: 0.5rem;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 50px;
    height: 3px;
    background: #ffa726;
  }
`;

const HighlightItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: rgb(85, 145, 204);
  border-radius: 8px;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateX(10px);
  }

  svg {
    font-size: 1.5rem;
    margin-right: 1rem;
    color: #2a5298;
  }
`;

const SkillsContainer = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-top: 1rem;
`;

const SkillTag = styled.div`
  padding: 0.5rem 1rem;
  background: #2a5298;
  color: white;
  border-radius: 20px;
  font-size: 0.9rem;
`;

const About = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <AboutContainer>
      <ContentWrapper>
        <ProfileSection>
        <ProfileImage>
          <img src={`${process.env.PUBLIC_URL}/foto_perfil.jpeg`} alt="Foto de perfil" /> 
        </ProfileImage>

          <h3>Mateus Henrique Martins</h3>
          <p>Desenvolvedor Front-End</p>
        </ProfileSection>

        <InfoSection>
          <SectionTitle>Sobre Mim</SectionTitle>
          
          <HighlightItem>
            <FaCode />
            <div>
              <h4>Aprendizado do Momento </h4>
              <p>Desenvolvimento de interfaces com React.js e TypeScript</p>
              <p>Interesse em desenvolvimento Front-end</p>
              <p>Inteligencia Artificial aplicada a casos clinicos </p>
            </div>
          </HighlightItem>

          <HighlightItem>
            <FaGraduationCap />
            <div>
              <h4>Formação</h4>
              <p>Bacharelado em Ciência da Computação - Universidade Federal de Alfenas - Minas Gerais</p>
            </div>
          </HighlightItem>
          
          <HighlightItem>
            <FaBriefcase />
            <div>
              <h4>Projetos - Unifal</h4>
              <p>Desenvolvimento Humano: Saúde, Educação e Trabalho: Projeto de extensão com intuito de ensinar informática básica para 
                crianças e adolescentes em instuições educacionais da cidade de Alfenas-MG.
              </p>
              <p>Conexão Digital - Conectando-se ao Universo Digital: Projeto de extensão com intuito de divulgar novidades da tecnologia 
                redes sociais
              </p>
            </div>
          </HighlightItem>


          <SectionTitle style={{ marginTop: '2rem' }}>Habilidades Técnicas</SectionTitle>
          <SkillsContainer>
            {['TypeScript', 'Node.js', 'C', 'Wordpress', 'Linux', 'Shell', 'Python', 'HTML', 'UI/UX', 'Figma'].map((skill) => (
              <SkillTag key={skill}>{skill}</SkillTag>
            ))}
          </SkillsContainer>
        </InfoSection>
      </ContentWrapper>
    </AboutContainer>
  );
};

export default About;
